var React = require('react');

function RightArrowBlack (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"rectangle","width":"24","height":"24","fill":"none","key":0}),React.createElement("path",{"id":"path","d":"M8.6,7.4,10,6l6,6-6,6L8.6,16.6,13.2,12Z","fill":"#686c71","fillRule":"evenodd","key":1})]);
}

RightArrowBlack.defaultProps = {"id":"Icon_-_Chevron_Master_Use_this_one","data-name":"Icon - Chevron (Master) Use this one","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RightArrowBlack;

RightArrowBlack.default = RightArrowBlack;
